import axios from 'axios';

import { DOCUMENTS_API_ENDPOINT } from 'constants/api';

const documentsAPI = axios.create({
  baseURL: DOCUMENTS_API_ENDPOINT,
});

export default documentsAPI;
